import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMagnifyingGlass, faMessage, faPhone, faPlus, faUser, faUserGroup } from '@fortawesome/free-solid-svg-icons';

function Online(){
    return (
        <>
        <div className="online">
            <div className="Online">
                ONLINE-2
                <hr></hr>
                <br></br>
                <div>
                    <div></div>
                    <div>BeardedBrro</div>
                    <div><FontAwesomeIcon icon={faMessage}/></div>
                    <div></div>
                </div>
            </div>
        </div>
        </>
    );
}
export default Online;